import { Film } from 'lucide-react';

import { definePanel } from '@/app/definePanel';
import { PanelMode, PanelTheme } from '@/types/panels';

export default definePanel({
    id: 'case_video',
    title: 'Video evidence',
    icon: Film,
    width: { min: 384, default: 672, max: Infinity, fill: true },
    modes: [PanelMode.View],
    themes: PanelTheme.Any,
    isHeaderless: true,
    // Clip the player to the panel's rounded corners, as the camera surface does.
    shouldClip: true,
    order: 100,
    hasNavButton: false,
});
